import { isHttpUrl } from "@/modules/audience-vote/domain/lib/contestant-photo";
import { audienceVoteApi } from "../api/client";

/** Public HTTPS URL as-is; storage keys → presigned read URL */
export async function resolveContestantPhotoPreviewUrl(
  eventId: string,
  photoRef: string,
): Promise<string | null> {
  const trimmed = photoRef.trim();
  if (!trimmed) return null;
  if (isHttpUrl(trimmed)) return trimmed;
  const { url } = await audienceVoteApi.getContestantPhotoReadUrl(
    eventId,
    trimmed,
  );
  return url;
}
